import {
  ConsultantGdprConsentFragment as Consent,
  GDPRCommunicationChannel as Channel,
  GDPRConsentType
} from "@graphql";

export function normalizeConsent(type: GDPRConsentType, consent?: Consent): Consent {
  const grantedDefault = consent?.granted === true;
  const channelDefault = [Channel.Verbal, Channel.Email].includes(
    consent?.communicationChannel
  )
    ? consent.communicationChannel
    : Channel.Email;

  if (consent) {
    return {
      ...consent,
      granted: grantedDefault,
      communicationChannel: channelDefault
    };
  }

  return {
    type,
    granted: grantedDefault,
    communicationChannel: channelDefault
  };
}
